import React from 'react';
import * as styles from '../styles/components/context-menu.css.ts';

interface RowContextMenuProps {
  visible: boolean;
  x: number;
  y: number;
  rowIndex: number;
  isExcluded?: boolean;
  hasComment?: boolean;
  isEditMode?: boolean;
  onExclude: () => void;
  onRestore?: () => void;
  onAddComment: () => void;
  onEditComment?: () => void;
  onDeleteRow?: () => void;
  onClose: () => void;
}

export const RowContextMenu: React.FC<RowContextMenuProps> = ({
  visible,
  x,
  y,
  isExcluded = false,
  hasComment = false,
  isEditMode = false,
  onExclude,
  onRestore,
  onAddComment,
  onEditComment,
  onDeleteRow,
  onClose
}) => {
  if (!visible) return null;

  return (
    <div
      data-testid="row-context-menu"
      className={styles.contextMenu}
      style={{ left: x, top: y }}
      onClick={(e) => e.stopPropagation()}
    >
      {!isExcluded ? (
        <button
          className={styles.contextMenuItem}
          onClick={() => {
            onExclude();
            onClose();
          }}
        >
          Exclude this row
        </button>
      ) : (
        onRestore && (
          <button
            className={styles.contextMenuItem}
            onClick={() => {
              onRestore();
              onClose();
            }}
          >
            Restore this row
          </button>
        )
      )}
      
      {!hasComment ? (
        <button
          className={styles.contextMenuItem}
          onClick={() => {
            onAddComment();
            onClose();
          }}
        >
          Add comment
        </button>
      ) : (
        onEditComment && (
          <button
            className={styles.contextMenuItem}
            onClick={() => {
              onEditComment();
              onClose();
            }}
          >
            Edit comment
          </button>
        )
      )}

      {/* Edit Mode時のみ行削除を表示 */}
      {isEditMode && onDeleteRow && (
        <>
          <div className={styles.contextMenuDivider} />
          <button
            className={`${styles.contextMenuItem} ${styles.contextMenuItemDanger}`}
            onClick={() => {
              onDeleteRow();
              onClose();
            }}
            data-testid="delete-row-button"
          >
            Delete Row
          </button>
        </>
      )}
    </div>
  );
};